@if (open()) {
  <div class="ui-bottom-sheet" role="presentation">
    <div
      class="ui-bottom-sheet-backdrop"
      role="presentation"
      aria-hidden="true"
      (click)="handleBackdropSelected()"
    ></div>
    <section
      #panel
      class="ui-bottom-sheet-panel"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      [class.ui-bottom-sheet-panel-sm]="isSmall()"
      [class.ui-bottom-sheet-panel-md]="isMedium()"
      [class.ui-bottom-sheet-panel-lg]="isLarge()"
      [class.ui-bottom-sheet-panel-snap-content]="isContentSnap()"
      [class.ui-bottom-sheet-panel-snap-large]="isLargeSnap()"
      [attr.aria-label]="accessibleLabel()"
      [attr.aria-labelledby]="labelledBy()"
      [attr.aria-describedby]="describedBy()"
      (keydown)="handleDialogKeydown($event)"
    >
      @if (showHandle()) {
        <span class="ui-bottom-sheet-handle" aria-hidden="true"></span>
      }
      @if (showHeader()) {
        <header class="ui-bottom-sheet-header">
          <span class="ui-bottom-sheet-heading">
            @if (hasTitle()) {
              <span class="ui-bottom-sheet-title" [id]="titleId()">{{
                title()
              }}</span>
            }
            @if (hasDescription()) {
              <span
                class="ui-bottom-sheet-description"
                [id]="descriptionId()"
                >{{ description() }}</span
              >
            }
          </span>
          <button
            class="ui-bottom-sheet-close"
            type="button"
            [attr.aria-label]="closeLabel()"
            (click)="handleCloseRequested()"
          >
            @if (closeIcon()) {
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                aria-hidden="true"
              >
                <path d="M5 5l14 14M19 5 5 19" />
              </svg>
            } @else {
              {{ closeLabel() }}
            }
          </button>
        </header>
      }
      <div class="ui-bottom-sheet-body">
        <ng-content />
      </div>
      <footer class="ui-bottom-sheet-actions">
        <ng-content select="[uiBottomSheetActions]" />
      </footer>
    </section>
  </div>
}
